import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import character1 from '../../assets/images/betshop-baccarat/character-1.png';
import character2 from '../../assets/images/betshop-baccarat/character-2.png';
import { cardsStore } from '../../store/cardsStore';

export const BetShopSideCounts = observer(() => {
  const { bankerTotalPoints, playerTotalPoints } = cardsStore;
  const t = useTranslation();

  return (
    <div className='bb-player-vs-banker'>
      <div className='bb-player-vs-banker-item player-side'>
        <div className='bb-player-vs-banker-heading'>
          <div className='bb-sign md blue-sign rotated-l'>
            <div className='bb-sign-inside'>
              <img src={character1} alt='' />
            </div>
          </div>
          <p className='b-player-vs-banker-txt'>{t('PLAYER')}</p>
        </div>
        <div className='bb-player-vs-banker-num'>
          <div className='bb-sign lg blue-sign'>
            <div className='bb-sign-inside'>
              <span>{playerTotalPoints || 0}</span>
            </div>
          </div>
        </div>
      </div>
      <div className='bb-player-vs-banker-item banker-side'>
        <div className='bb-player-vs-banker-heading'>
          <p className='b-player-vs-banker-txt'>{t('BANKER')}</p>
          <div className='bb-sign md rotated-r red-sign'>
            <div className='bb-sign-inside'>
              <img src={character2} alt='' />
            </div>
          </div>
        </div>
        <div className='bb-player-vs-banker-num'>
          <div className='bb-sign lg red-sign'>
            <div className='bb-sign-inside'>
              <span>{bankerTotalPoints || 0}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
